import React, { useEffect, useState } from "react";
import Hero from "./Hero";
import heroVideo from "../../assets/medical-video.mp4";
import {
  SHARED_HERO_SUBHEADING,
  SHARED_HERO_INTRO,
  SHARED_HERO_CREDIBILITY,
  SHARED_HERO_BOTTOM_PARAGRAPH,
} from "../../data/medicalHeroContent";
import { getMedicalHomepageContent } from "../../api/cmsApi";

function extractMedicalHero(payload) {
  const source = payload?.data || payload || {};
  const heroBlock = source?.Hero || source?.hero || source?.heroSection || {};
  const credibility = source?.Credibility || source?.credibility || {};

  const title =
    heroBlock?.title ||
    source?.title ||
    "Healthcare Personalberatung";
  const subheading =
    heroBlock?.subtitle ||
    source?.subheading ||
    SHARED_HERO_SUBHEADING;
  const intro =
    heroBlock?.description ||
    source?.intro ||
    SHARED_HERO_INTRO;
  const bottomParagraph =
    source?.bottomParagraph ||
    source?.bottom_paragraph ||
    SHARED_HERO_BOTTOM_PARAGRAPH;

  const statsFromCms = Array.isArray(credibility?.stats)
    ? credibility.stats
        .map((s) => ({
          value: s?.value,
          label: s?.label,
        }))
        .filter((s) => s.value || s.label)
    : null;

  const cmsCredibility =
    statsFromCms && statsFromCms.length > 0
      ? {
          ...SHARED_HERO_CREDIBILITY,
          stats: statsFromCms,
          ratingText:
            credibility?.ratingText || SHARED_HERO_CREDIBILITY.ratingText,
          showAvatars:
            credibility?.showAvatars ?? SHARED_HERO_CREDIBILITY.showAvatars,
        }
      : SHARED_HERO_CREDIBILITY;

  return {
    title,
    subheading,
    intro,
    bottomParagraph,
    credibility: cmsCredibility,
  };
}

export default function MedicalHero() {
  const [heroContent, setHeroContent] = useState({
    title: "Healthcare Personalberatung",
    subheading: SHARED_HERO_SUBHEADING,
    intro: SHARED_HERO_INTRO,
    bottomParagraph: SHARED_HERO_BOTTOM_PARAGRAPH,
    credibility: SHARED_HERO_CREDIBILITY,
  });

  useEffect(() => {
    getMedicalHomepageContent()
      .then((payload) => {
        setHeroContent(extractMedicalHero(payload));
      })
      .catch((error) => {
        console.error("Medical homepage CMS fetch failed:", error);
      });
  }, []);

  return (
    <Hero
      title={heroContent.title}
      subheading={heroContent.subheading}
      intro={heroContent.intro}
      video={heroVideo}
      credibility={heroContent.credibility}
      bottomParagraph={heroContent.bottomParagraph}
      statsAsFloatingCards
      useBrandBackground={false}
    />
  );
}
